// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header'; // Import Header
import platesImage from '../assets/plates.png';
import '../components/Header.css'; // Import Header CSS
import '../styles/AboutSection.css'; // Import CSS for the new section
import '../styles/OurValues.css'; // Import CSS for the values section
// Import MediaProvider along with MediaPlayer
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

const Home = () => {
    return (
        <main className="modern-layout">
            <Header /> {/* Add the Header component here */}
            
            {/* Main hero section */}
            <div className="gradient_background">
                <div className="content-container">
                    
                    {/* Embedded looping YouTube video using Vidstack */}
                    <div
                        style={{
                            margin: '2rem 0',
                            width: '100vw',
                            position: 'relative',
                            left: '50%',
                            right: '50%',
                            marginLeft: '-50vw',
                            marginRight: '-50vw',
                            maxWidth: '100vw',
                        }}
                    >
                        <MediaPlayer
                            src="https://www.youtube.com/watch?v=nb2ZDgO0Ft4"
                            title="SOPHIE CRM automation video"
                            playsInline
                            autoPlay
                            muted
                            loop
                            style={{ width: '100%', height: 'auto' }}
                        >
                            <DefaultVideoLayout icons={defaultLayoutIcons} />
                            <MediaProvider />
                        </MediaPlayer>
                    </div>
                    
                    <div className="tagline-description">
                        AI-powered CRM automation that give your business super powers.
                    </div>
                    

                    <div className="cta-container">
                        {/* <Link to="/crm-questionnaire" className="cta-button">Fill CRM Questionnaire</Link> */}
                        <Link to="/request-demo" className="cta-button cta-button-gradient">Request a Demo</Link>
                    </div>
                </div>
            </div>
            
            {/* CRM Automation Section */}
            <section id="crm-automation" className="feature-section">
                <div className="feature-content">
                    <h2>Automate Your CRM Workflows</h2>
                    <p>
                        SOPHIE is an AI-powered CRM automation tool built for Salesforce and HubSpot users 
                        who are tired of admin chaos. It automates the collection, naming, and filing of 
                        documents like signed agreements, usage reports, and quotes — placing them exactly 
                        where they belong in your CRM.
                    </p>
                    <p>
                        No more manual uploads. No more missing files. Just a clean, organized CRM that 
                        works for you — not the other way around.
                    </p>
                </div>
            </section>
            
            {/* Invoice Management Section */}
            <section id="invoice-management" className="feature-section alt-bg">
                <div className="feature-content">
                    <h2>Match, Review, and Validate Invoices Automatically</h2>
                    <p>
                        SOPHIE automates invoice management by cross-checking every incoming invoice against 
                        purchase orders and signed agreements. If there's a mismatch, missing contract, or 
                        duplicate entry, SOPHIE flags it instantly — before it causes problems downstream.
                    </p>
                    <p>
                        Built for ERP and CRM integration (SAP, Salesforce, and more), SOPHIE removes the 
                        need for tedious manual reviews and protects your business from costly errors.
                    </p>
                </div>
            </section>
            
            {/* About Us Section */}
            <section id="about-us" className="about-section">
                <div className="about-content">
                    <h2>About us</h2>
                    <p>
                        SOPHIE is your tireless, clever, and slightly overachieving<br />
                        office assistant — built with one mission in mind:<br />
                        To bring the focus of the sales process<br />
                        back to the customer — not the software.
                    </p>
                    <p>
                        We believe your time should be spent building relationships,<br />
                        closing deals, and making progress — not hunting<br />
                        for documents, double-checking invoices,<br />
                        or updating CRM fields for the fifth time today.<br />
                        SOPHIE knows your business inside and out and is always<br />
                        one step ahead — helping you work smarter, not harder.
                    </p>
                    <h3>Our vision?</h3>
                    <p>
                        A workday without the grind.<br />
                        Where boring routines are automated.<br />
                        Where meetings have purpose.<br />
                        And where your team finally<br />
                
                        has the space to think, create, and connect.<br />
                        We exist to make work feel less like work<br />
                        — and more like progress.
                    </p>
                </div>
            </section>

            {/* Our Values Section */}
            <section id="our-values" className="values-section">
                <h2>Our Values</h2>
                <div className="values-container">
                    <div className="value-card">
                        <h3>Usefulness</h3>
                        <p>We create tools that truly solve
problems. Every feature we
build, every decision we make,
is guided by one question: Does
this make our customers’ lives
easier or better?</p>
                    </div>
                    <div className="value-card">
                        <h3>Curiosity</h3>
                        <p>We ask questions, explore
ideas, and challenge
assumptions. Curiosity fuels our
innovation. It’s how we discover
smarter ways to work and
uncover insights others miss.</p>
                    </div>
                    <div className="value-card">
                        <h3>Motivation</h3>
                        <p>We’re driven to make an
impact. Whether it’s a small
improvement or a bold leap
forward, we bring energy and
purpose to everything we do.</p>
                    </div>
                    <div className="value-card">
                        <h3>Discipline</h3>
                        <p>Great ideas mean nothing
without execution. We take
pride in focused, consistent
work — from planning to
performance, we stay sharp
and follow through.</p>
                    </div>
                    <div className="value-card">
                        <h3>Accountability</h3>
                        <p>We own our outcomes. When
we commit, we deliver — to our
customers, our teammates, and
ourselves. If something goes
wrong, we fix it. If it goes right,
we build on it.</p>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="about-section">
                <div className="about-content">
                    <h2>Contact</h2>
                    <p>
                        Sophie Datagen Ltd.<br />
                        128 City Road, London,<br />
                        United Kingdom, EC1V 2NX
                    </p>
                    <p className="contact-email">
                        Sales | Enquiries:<br />
                        <a href="mailto:hello@sophiedoc.ai" className="special-email-link">
                            hello<span className="at-symbol">@</span>sophiedoc.ai
                        </a>
                    </p>
                </div>
            </section>

            {/* Corner image - Keep outside the main sections if it should be fixed */}
            <img src={platesImage} alt="" className="corner-image" aria-hidden="true" />
        </main>
    );
};

export default Home;